export default {
  seo: {
    home: {
      title: 'Artemida Studio — Creative Digital Solutions',
      description:
        'We create custom websites of any complexity: landing pages, corporate sites, and AI assistants.',
      keywords: 'web development, landing page, corporate website, AI',
    },
    // 🔽 нове: SEO для списку блогу
    blog: {
      title: 'Blog — Artemida Studio',
      description:
        'Insights about web development, design, AI assistants, and building modern business websites.',
      keywords: 'blog, web development, design, AI, websites',
    },
  },

  header: {
    homeLink: 'Home',
    aboutUsLink: 'About Us',
    servicesLink: 'Services',
    ourProjectsLink: 'Our projects',
    contact: 'Contact',
    blogLink: 'Blog',
  },
  heroSection: {
    companyDescription: 'We create custom websites of any complexity',
    contactUs: 'Contact Us',
  },
  aboutUsSection: {
    aboutUsTitle: 'About Us',
    aboutUsDescription:
      'At Artemida Studio, we specialize in creating custom landing pages and corporate websites that help businesses establish a strong online presence.\n\n' +
      'By combining creativity, the latest technologies, and a personalized approach, we build websites that are not only aesthetically appealing but also fast, user-friendly, and fully responsive.\n\n' +
      'Whether you need a high-converting landing page or a professional corporate website, Artemida Studio is here to bring your vision to life with high-quality, custom solutions.\n\n' +
      'Choose professionalism and creativity – let’s build your perfect website together!',
  },

  // 🔽 НОВЕ: вся сторінка Services керується з перекладу
  services: {
    ourServices: 'Our Services',
    servicesDescription:
      'We specialize in creating high-quality, custom digital solutions to elevate your business',
    contactUs: 'Contact Us',
    items: [
      {
        key: 'landing',
        title: 'Landing \n Page',
        descriptionList: [
          `A well-designed landing page is a powerful tool for attracting customers, increasing conversions, and boosting your brand’s online presence. At Artemida Studio, we create high-quality, custom landing pages tailored to your business goals.`,
          `✔️ Modern & Unique Design – Visually stunning, brand-aligned pages that capture attention.`,
          `✔️ High Conversion Rate – Optimized layouts and compelling CTAs to drive engagement.`,
          `✔️ Fast & Responsive – Lightning-fast performance and seamless experience across all devices.`,
          `✔️ SEO & Marketing Ready – Built with best practices to improve visibility and attract organic traffic.`,
          `✔️ Fully Customizable – Every detail tailored to your specific needs and business identity.`,
        ],
      },
      {
        key: 'corporate',
        title: 'Corporate Website',
        descriptionList: [
          `A professional corporate website is essential for building credibility, showcasing your brand, and engaging customers. At Artemida Studio, we craft custom corporate websites that reflect your company’s values and help you stand out in the digital world.`,
          `✔️ Professional & Unique Design – A sleek, modern look tailored to your brand identity.`,
          `✔️ Fully Customizable – Every element is designed to fit your business needs and goals.`,
          `✔️ Fast & Secure – Optimized for speed, security, and flawless performance.`,
          `✔️ SEO & Marketing Friendly – Built with best practices to enhance online visibility and attract potential clients.`,
          `✔️ Mobile & User-Friendly – Fully responsive design for a seamless experience on all devices.`,
          `✔️ Easy Content Management – Simple and efficient updates with a user-friendly CMS.`,
        ],
      },
      {
        key: 'ai',
        title: 'AI Assistance Integration',
        descriptionList: [
          `Enhance your website with the power of AI! At Artemida Studio, we integrate advanced AI Assistants that improve user experience, automate tasks, and boost customer engagement. Whether you need a smart chatbot, automated support, or AI-driven recommendations, we create seamless solutions tailored to your business.`,
          `✔️ 24/7 Customer Support – AI-powered chatbots handle inquiries anytime, improving customer satisfaction.`,
          `✔️ Seamless Website Integration – Works smoothly within your site, enhancing functionality without disruption.`,
          `✔️ Personalized User Experience – AI-driven interactions tailored to user needs and preferences.`,
          `✔️ Lead Generation & Sales Boost – Engage visitors, collect leads, and guide customers toward purchases.`,
          `✔️ Automation & Efficiency – Streamline processes, reducing workload and response times.`,
          `✔️ Custom AI Solutions – Fully adaptable to your business model and specific requirements.`,
        ],
      },
    ],
  },
  contactSection: {
    title: "LET'S DISCUSS YOUR PROJECT",
    placeholderName: 'Name',
    placeholderPhone: 'Phone',
    placeholderEmail: 'Email',
    placeholderMessage: 'Tell us about your project',
    sendButton: 'Send',
  },
};
